import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { SendError } from '../features/commons/store/actions';
import '../assets/styles/NotFound.scss';
import ErrorOutline from '../assets/images/error-outline';

function NotFound() {
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(SendError({ title: '404 Rendered', error: JSON.stringify({ user, location: window.location }) }));
  }, [user]);

  const GoToHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found">
      <div className="not-found--icon-error"><ErrorOutline /></div>
      <div className="not-found--title">It appears that this page can not be found.</div>
      <div className="not-found--subtitle">Take a deep breath and go back to home.</div>
      <button className="not-found--button active" type="button" onClick={GoToHome}>Go to Home</button>
    </div>
  );
}

export default NotFound;
